import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-url-not-found',
  templateUrl: './url-not-found.component.html',
  styleUrls: ['./url-not-found.component.css'],
  standalone: true
})
export class UrlNotFoundComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
